export default __webpack_public_path__ + "1443b8d5c8132d20b2996019e2ed9c28.svg";